__turbopack_context__.v({
  "content": "styles-module__nDUGMW__content",
  "fiftyfifty": "styles-module__nDUGMW__fiftyfifty",
  "heading": "styles-module__nDUGMW__heading",
  "image": "styles-module__nDUGMW__image",
  "imageContainer": "styles-module__nDUGMW__imageContainer",
  "right": "styles-module__nDUGMW__right",
  "textContent": "styles-module__nDUGMW__textContent",
});
